import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@mui/material';
import { NetworkClassification, type InventoryResource } from '@repo/api-gw-sdk';
import { Tag } from '@/components/tag';
import { useRoles } from '@/contexts/useRoles';
import { NetworkClassifications } from '@/data/inventory/resourceClassifications';
import { AutoClassification } from './autoClassifcationButtons';
export const NetworkClassificationTag = t0 => {
  const $ = _c(5);
  const {
    networkClassification
  } = t0;
  const meta = NetworkClassifications[networkClassification];
  const t1 = meta?.description ?? meta?.title ?? networkClassification;
  const t2 = meta?.title ?? networkClassification;
  let t3;
  if ($[0] !== t2) {
    t3 = <Tag variant="primary" content={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t1 || $[3] !== t3) {
    t4 = <Tooltip title={t1}>{t3}</Tooltip>;
    $[2] = t1;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export function NetworkClassificationViewer(t0) {
  const $ = _c(42);
  const {
    entity,
    setNetworkClassificationOverrideOpen,
    restartNetworkClassification
  } = t0;
  const {
    isAuthorizedResource
  } = useRoles();
  const details = entity.classifications?.networkClassificationDetails;
  const level = details?.networkClassification ?? "";
  let t1;
  if ($[0] !== entity || $[1] !== isAuthorizedResource) {
    t1 = isAuthorizedResource("update:network_classification", entity);
    $[0] = entity;
    $[1] = isAuthorizedResource;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const disabled = !t1;
  if (details?.isOverridden) {
    let t2;
    if ($[3] !== disabled || $[4] !== restartNetworkClassification) {
      t2 = disabled ? _temp : () => restartNetworkClassification();
      $[3] = disabled;
      $[4] = restartNetworkClassification;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== disabled || $[7] !== setNetworkClassificationOverrideOpen) {
      t3 = disabled ? _temp2 : () => setNetworkClassificationOverrideOpen();
      $[6] = disabled;
      $[7] = setNetworkClassificationOverrideOpen;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[9] !== disabled || $[10] !== setNetworkClassificationOverrideOpen) {
      t4 = disabled ? _temp3 : () => setNetworkClassificationOverrideOpen();
      $[9] = disabled;
      $[10] = setNetworkClassificationOverrideOpen;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    let t5;
    if ($[12] !== disabled || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
      t5 = <AutoClassification testId="network-classification-auto-classification-buttons-override" textOn="" isAutoClassificationOn={false} restartDetectionClicked={t2} editOverridesClicked={t3} setEditorOpen={t4} disabled={disabled} />;
      $[12] = disabled;
      $[13] = t2;
      $[14] = t3;
      $[15] = t4;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    let t6;
    if ($[17] !== level) {
      t6 = !!level && NetworkClassifications[level] && <NetworkClassificationTag networkClassification={level} />;
      $[17] = level;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    let t7;
    if ($[19] !== t5 || $[20] !== t6) {
      t7 = <>{t5}{t6}</>;
      $[19] = t5;
      $[20] = t6;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    return t7;
  }
  const isUnknown = level === NetworkClassification.NETWORK_CLASSIFICATION_UNKNOWN;
  const textOn = isUnknown ? "Network exposure could not be determined" : NetworkClassifications[level] ? "This network exposure was detected:" : "No network exposure was detected";
  let t2;
  if ($[22] !== disabled || $[23] !== restartNetworkClassification) {
    t2 = disabled ? _temp4 : () => restartNetworkClassification();
    $[22] = disabled;
    $[23] = restartNetworkClassification;
    $[24] = t2;
  } else {
    t2 = $[24];
  }
  let t3;
  if ($[25] !== disabled || $[26] !== setNetworkClassificationOverrideOpen) {
    t3 = disabled ? _temp5 : () => setNetworkClassificationOverrideOpen();
    $[25] = disabled;
    $[26] = setNetworkClassificationOverrideOpen;
    $[27] = t3;
  } else {
    t3 = $[27];
  }
  let t4;
  if ($[28] !== disabled || $[29] !== setNetworkClassificationOverrideOpen) {
    t4 = disabled ? _temp6 : () => setNetworkClassificationOverrideOpen();
    $[28] = disabled;
    $[29] = setNetworkClassificationOverrideOpen;
    $[30] = t4;
  } else {
    t4 = $[30];
  }
  let t5;
  if ($[31] !== disabled || $[32] !== t2 || $[33] !== t3 || $[34] !== t4 || $[35] !== textOn) {
    t5 = <AutoClassification testId="network-classification-auto-classification-buttons-auto" textOn={textOn} isAutoClassificationOn={true} restartDetectionClicked={t2} editOverridesClicked={t3} setEditorOpen={t4} disabled={disabled} />;
    $[31] = disabled;
    $[32] = t2;
    $[33] = t3;
    $[34] = t4;
    $[35] = textOn;
    $[36] = t5;
  } else {
    t5 = $[36];
  }
  let t6;
  if ($[37] !== level) {
    t6 = !!level && NetworkClassifications[level] && <NetworkClassificationTag networkClassification={level} />;
    $[37] = level;
    $[38] = t6;
  } else {
    t6 = $[38];
  }
  let t7;
  if ($[39] !== t5 || $[40] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[39] = t5;
    $[40] = t6;
    $[41] = t7;
  } else {
    t7 = $[41];
  }
  return t7;
}
function _temp6() {}
function _temp5() {}
function _temp4() {}
function _temp3() {}
function _temp2() {}
function _temp() {}